<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/2">
      <transition name="fade">
        <Card
          :title="currentBranch.name || cardTitle"
          v-show="loaded"
        >
          <form @submit.prevent>
            <div class="py-3">
              <AvatarCroper :branch_id.sync="branch_id" />
            </div>
            <div class="py-3">
              <vs-input
                label="Название филиала* (это название увидят гости)"
                v-model="form.name"
                name="name"
                v-validate="'required'"
                :danger="errors.has('name')"
                :danger-text="errors.first('name')"
              />
              <vs-input
                label="Имя контактного лица*"
                v-model="form.first_name"
                name="first_name"
                v-validate="'required'"
                :danger="errors.has('first_name')"
                :danger-text="errors.first('first_name')"
              />
              <!--<vs-input-->
                <!--label="Фамилия контактного лица"-->
                <!--placeholder="Фамилия контактного лица"-->
                <!--v-model="form.last_name"-->
              <!--/>-->
              <InputPhone
                label="Телефон*"
                v-model="form.phone_number"
                errorsScope="phone_number"
              />
              <vs-input
                type="email"
                label="Почта*"
                v-model="form.email"
                name="email"
                v-validate="'required|email'"
                :danger="errors.has('email')"
                :danger-text="errors.first('email')"
              />
              <vs-input
                label="Адрес"
                v-model="form.address"
                name="address"
                :danger="errors.has('address')"
                :danger-text="errors.first('address')"
              />

              <div v-if="canSeePaymentsStrategy" class="font-medium mb-1">Распределение чаевых: </div>
              <ul v-if="canSeePaymentsStrategy" class="centerx">
                <li>
                  <vs-radio
                    v-model="form.payments_strategy"
                    vs-value="PM"
                  >переводить на общий счет</vs-radio>
                </li>
                <li>
                  <vs-radio
                    v-model="form.payments_strategy"
                    vs-value="PE"
                  >переводить на счета сотрудникам</vs-radio>
                </li>
              </ul>
              <div class="mt-6">
                <vs-button
                  button="submit"
                  @click="updateBranch"
                  :disabled="!(validateForm)"
                >{{ buttonTitle }}</vs-button>
              </div>
            </div>
          </form>
        </Card>
      </transition>
    </div>
    <div
      class="vx-col w-full md:w-1/2"
      v-if="showEmployeeBankCard && form.payments_strategy == 'PM'"
    >
      <!-- Bank Card -->
      <!-- FIXME: update/create component issue -->
      <!-- <Card class="mb-10">
        <vs-input
          label="Номер банковской карты"
          v-mask="'#### #### #### ####'"
          v-model="bankCardForm.card_number"
          name="card_number"
          v-validate="'required|length:19'"
          :danger="errors.has('card_number')"
          :danger-text="errors.first('card_number')"
        />
        <vs-input
          label="Действительна до"
          v-mask="'##/##'"
          v-model="bankCardForm.card_date"
          name="card_date"
          v-validate="'date_format:MM/yy'"
          :danger="errors.has('card_date')"
          :danger-text="errors.first('card_date')"
        />
        <vs-input
          label="Имя и фамилия"
          name="card_name"
          v-model="bankCardForm.card_name"
          v-validate="'required|alpha_spaces'"
          :danger="errors.has('card_name')"
          :danger-text="errors.first('card_name')"
        />
        <vs-button
          :disabled="!(validateBankCardForm)"
          @click="saveBankCard"
        >Сохранить </vs-button>
      </Card> -->
      <!-- Bank account -->
      <!-- FIXME: update/create component issue -->
      <Card role="region" title="Платежные данные">
        <form @submit.prevent>
          <InputAccountNumber
            label="Номер счета получателя"
            v-model="bankAccountForm.account_number"
            errorsScope="account_number"
          />
          <vs-input
            label="БИК банка, выпустившего карту"
            placeholder="123456789"
            v-mask="'#########'"
            v-model="bankAccountForm.bik"
            v-validate="'required|regex:^[0-9]{9}$'"
            name="bik"
            :danger="errors.has('bik')"
            danger-text="БИК должен состоять из 9 цифр"
          />
          <vs-input
            label="ФИО получателя денежных средств"
            placeholder="Иванов Иван Иванович"
            name="account_name"
            v-model.trim="bankAccountForm.account_name"
            v-validate="'required|fullName'"
            :danger="errors.has('account_name')"
            danger-text="Введите полное ФИО на кириллице"
          />
          <p class="mb-6">
            <small>
              Чтобы узнать реквизиты своего счета:<br>
              В мобильном приложении своего банка выберите карточку,
              на которую хотите получать чаевые, а дальше нажмите - получить реквизиты.
            </small>
          </p>
          <vs-button
            button="submit"
            :disabled="!validateBankAccountForm"
            @click="saveBankAccount"
          >Сохранить </vs-button>
        </form>
      </Card>
    </div>
  </div>
</template>
<script>
import {
  BRANCH_FETCH,
  BRANCHES_FETCH,
  BRANCH_UPDATE,
  BRANCH_CREATE,
  BRANCH_BANK_CARD_CREATE,
  BRANCH_BANK_CARD_UPDATE,
  BRANCH_BANK_ACCOUNT_CREATE,
  BRANCH_BANK_ACCOUNT_UPDATE
} from '@/store/action.types'
import {
  mapGetters
} from 'vuex'
import {
  Form
} from '@/common/form'
import AvatarCroper from '@/views/branches/components/AvatarCroper'
export default {
  props: {
    cardTitle: {
      type: String,
      required: false
    },
    buttonTitle: {
      type: String,
      required: true
    },
    showEmployeeBankCard: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      loaded: false,
      form: {},
      hidePaymentsStrategy: true,
      bankCardForm: new Form({
        'card_number': '',
        'card_date': '',
        'card_name': ''
      }),
      bankAccountForm: new Form({
        'account_number': '',
        'bik': '',
        'account_name': ''
      }),
      image: 'https://images.pexels.com/photos/1111534/pexels-photo-1111534.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
    }
  },
  components: {
    AvatarCroper
  },
  computed: {
    ...mapGetters(['currentBranch', 'companyBranches', 'companyTypes', 'currentBranchBankCard', 'currentBranchBankAccount', 'currentUser']),
    validateForm() {
      return this.form.name !== '' && this.form.first_name !== '' && this.form.payments_strategy !== '' && this.form.phone_number !== '' && this.form.email !== ''
    },
    validateBankCardForm() {
      return this.bankCardForm.card_number !== '' && this.bankCardForm.card_date !== '' && this.bankCardForm.card_name !== ''
    },
    validateBankAccountForm() {
      return this.bankAccountForm.account_number !== '' && this.bankAccountForm.bik !== '' && this.bankAccountForm.account_name !== ''
    },
    branch_id() {
      return this.$route.params.id
    },
    canSeePaymentsStrategy() {
      return !this.hidePaymentsStrategy
    }
  },
  watch: {
    '$route.params.id': function(id) {
      this.initBranchData(id)
    }
  },
  created() {
    if (this.buttonTitle === 'Сохранить') {
      this.form = new Form(this.currentBranch)
      this.bankCardForm = new Form(this.currentBranchBankCard)
      this.bankAccountForm = new Form(this.currentBranchBankAccount)
    } else {
      this.form = new Form({
        address: '',
        name: '',
        payments_strategy: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        bank_card: {
          card_number: null,
          card_date: null,
          card_name: null
        },
        bank_account: {
          account_number: null,
          bik: null,
          account_name: null
        }
      })
    }
  },
  mounted() {
    if (this.buttonTitle === 'Сохранить') {
      this.initBranchData(this.$route.params.id)
    } else {
      this.loaded = true
    }
  },
  methods: {
    async initBranchData(id) {
      this.loaded = false
      this.$vs.loading()
      await this.$store.dispatch(BRANCH_FETCH, id).then(() => {
        this.form = new Form(this.currentBranch)

        // Временное решение для того, чтобы убрать выбор стратегии оплаты (общак или индивидуально).
        // https://jira.skbkontur.ru/browse/MT-670
        if (this.form.payments_strategy === null || this.form.payments_strategy === '') {
          this.form.payments_strategy = 'PE'
        }
        this.hidePaymentsStrategy = this.form.payments_strategy === 'PE'
        this.bankCardForm = new Form(this.currentBranchBankCard)
        this.bankAccountForm = new Form(this.currentBranchBankAccount)
        this.$vs.loading.close()
      })
      this.loaded = true
    },
    updateBranch() {
      this.hidePaymentsStrategy = this.form.payments_strategy === 'PE'
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const trackData = {
            orgName: !!this.form.name,
            phone: !!this.form.phone_number,
            email: !!this.form.email,
            address: !!this.form.address,
            spreadScheme: this.form.payments_strategy
              ? (this.form.payments_strategy === 'PM' ? 'common' : 'individual ')
              : false
          }
          const payload = {
            'id': this.$route.params.id,
            'address': this.form.address,
            'name': this.form.name,
            'first_name': this.form.first_name,
            'last_name': this.form.last_name,
            'phone_number': this.form.phone_number,
            'email': this.form.email,
            'payments_strategy': this.form.payments_strategy,
            'notify': this.$vs.notify
          }
          this.$emit('saveBranch', trackData)
          if (this.buttonTitle !== 'Создать') {
            this.$store.dispatch(BRANCH_UPDATE, payload).then(() => {
              this.$vs.loading.close()
            })
          } else {
            this.$store.dispatch(BRANCH_CREATE, payload).then(() => {
              this.$store.dispatch(BRANCHES_FETCH)
              this.$vs.loading.close()
            })
          }
        }
      })
    },
    saveBankAccount() {
      if (['044525444', '044525416'].includes(this.bankAccountForm.bik)) {
        this.$vs.notify({
          title: 'Ошибка',
          text: 'Вывод на карты и кошельки QIWI и Яндекс не поддерживается из-за правил использования кошельков.'
        })
      } else {
        this.$validator.validateAll().then(result => {
          this.$emit('saveBankAccount')
          if (result) {
            // this.$vs.loading()
            const payload = {
              'id': this.$route.params.id,
              'account_number': this.bankAccountForm.account_number,
              'bik': this.bankAccountForm.bik,
              'account_name': this.bankAccountForm.account_name,
              'notify': this.$vs.notify
            }
            if (this.currentBranchBankAccount.account_number == null) {
              this.$store.dispatch(BRANCH_BANK_ACCOUNT_CREATE, payload).then(() => {
                this.$vs.loading.close()
              })
            } else {
              this.$store.dispatch(BRANCH_BANK_ACCOUNT_UPDATE, payload).then(() => {
                this.$vs.loading.close()
              })
            }
          }
        })
      }
    },
    saveBankCard() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const payload = {
            'id': this.$route.params.id,
            'card_number': this.bankCardForm.card_number,
            'card_date': this.bankCardForm.card_date,
            'card_name': this.bankCardForm.card_name,
            'notify': this.$vs.notify
          }

          if (this.currentBranchBankCard.card_number == null) {
            this.$store.dispatch(BRANCH_BANK_CARD_CREATE, payload).then(() => {
              this.$vs.loading.close()
            })
          } else {
            this.$store.dispatch(BRANCH_BANK_CARD_UPDATE, payload).then(() => {
              this.$vs.loading.close()
            })
          }
        }
      })
    }
    // saveBankCard() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       this.$vs.loading()
    //       const payload = {
    //         'id': this.$route.params.id,
    //         'card_number': this.bankCardForm.card_number,
    //         'card_date': this.bankCardForm.card_date,
    //         'card_name': this.bankCardForm.card_name,
    //         'notify': this.$vs.notify
    //       }

    //       if (this.currentBranchBankCard.card_number == null) {
    //         this.$store.dispatch(BRANCH_BANK_CARD_CREATE, payload).then(() => {
    //           this.$vs.loading.close()
    //         })
    //       } else {
    //         this.$store.dispatch(BRANCH_BANK_CARD_UPDATE, payload).then(() => {
    //           this.$vs.loading.close()
    //         })
    //       }
    //     }
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped></style>
